import { useState } from "react";
import { PincodeTable, RightWrapper } from "../../../components";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Button } from "@/components";
import { BiSolidEditAlt } from "react-icons/bi";
import { RiFileExcel2Line } from "react-icons/ri";
import { HiOutlineUpload } from "react-icons/hi";
import { useNavigate } from "react-router";
import UpdatePincode from "./UpdatePincodeChart";

const Pincode = () => {
  const [sheetOpen, setSheetOpen] = useState(false);
  const navigate = useNavigate();
  const handleView = () => {
    navigate("edit");
  };
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <div className="flex flex-col md:flex-row lg:justify-between items-end gap-6 lg:gap-2">
          <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
            Pincode
          </h1>
          <div className="flex gap-1 ">
            <Button
              size="xs"
              icon={BiSolidEditAlt}
              onClick={() => handleView({})}
            >
              Edit Pincode
            </Button>
            <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
              <SheetTrigger asChild>
                <Button size="xs" icon={HiOutlineUpload}>
                  Update All Pincode
                </Button>
              </SheetTrigger>
              <SheetContent aria-describedby="">
                <SheetHeader>
                  <SheetTitle>Update All Pincode</SheetTitle>
                </SheetHeader>
                <UpdatePincode setSheetOpen={setSheetOpen} />
              </SheetContent>
            </Sheet>
          </div>
        </div>
        <PincodeTable />
      </div>
    </RightWrapper>
  );
};

export default Pincode;
